import moment from 'moment';
import * as types from '../mutation-types'
import store from '@/store'

export default {
	namespaced: true,

	state: {
		regionPlans: [],
		activeRegionPlan: {},
		statistics: []
	},

	actions: {
		fetchAll({ commit }, { employeeId }) {
			return window.axios.get(`/region-plans/employee/${employeeId}`).then(({ data }) => {
				const isWeeklyPlan = store.state.configurations.weeklyPlan

				const startWeek = new Date().getDay() !== 6 ? moment().startOf('week').add(1, 'week').subtract(1, 'day').format('YYYY-MM-DD') : moment().add(1, 'week').format('YYYY-MM-DD')

				const activeRegionPlan = isWeeklyPlan
					? data.find(c => moment(c.fromDate).format('YYYY-MM-DD') === startWeek) || {}
					: data.find(c => moment(c.fromDate).format('YYYY-MM') === moment().add(1, 'months').format('YYYY-MM')) || {};

				commit(types.STORE_REGION_PLANS, data);
				commit(types.STORE_ACTIVE_REGION_PLAN, activeRegionPlan);
				return data;
			})
		},

		fetchByDate({ commit }, { fromDate, toDate }) {
			return window.axios.get('/region-plans', { params: { fromDate, toDate } }).then(({ data }) => data);
		},

		create({ commit }, { employeeId, fromDate, toDate, name, active }) {
			return window.axios.post('/region-plans', { employeeId, fromDate, toDate, name, active: active !== false }).then(({ data }) => data);
		},

		fetchStatistics({ commit }, { fromDate, toDate, employeeIds, regionIds } = {}) {
			return window.axios.get('/region-plans/statistics', {
				params: { fromDate, toDate, employeeIds, regionIds },
				// the endpoint expects repeated keys (collectionFormat: multi); axios' default
				// `ids[]=` form is not bound by the API and the filter is silently ignored
				paramsSerializer: { indexes: null },
				preventHandling: true
			}).then(({ data }) => {
				commit(types.STORE_REGION_PLANS_STATISTICS, data || []);
				return data;
			})
		},

		resetStatistics({ commit }) {
			commit(types.RESET_REGION_PLANS_STATISTICS);
		},
	},

	mutations: {
		[types.STORE_REGION_PLANS](state, regionPlans) {
			state.regionPlans = regionPlans;
		},
		[types.STORE_ACTIVE_REGION_PLAN](state, activeRegionPlan) {
			state.activeRegionPlan = activeRegionPlan;
		},
		[types.STORE_REGION_PLANS_STATISTICS](state, statistics) {
			state.statistics = statistics;
		},
		[types.RESET_REGION_PLANS_STATISTICS](state) {
			state.statistics = [];
		},
	},

	getters: {
		getRegionPlanById: state => id => state.regionPlans.find(c => c.id === id),

		getRegionPlansStatisticsSummary: state => {
			const totalEntities = state.statistics.reduce((sum, region) => sum + (region.totalEntitiesCount || 0), 0);
			const visitedCount = state.statistics.reduce((sum, region) => sum + (region.visitedEntityIds?.length || 0), 0);

			return {
				totalEntities,
				visitedCount,
				remainingCount: totalEntities - visitedCount,
				percentage: totalEntities ? Math.round((visitedCount / totalEntities) * 100) : 0
			};
		}
	}
}
